import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, X } from 'lucide-react';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600 && !isDismissed) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);
  return <AnimatePresence data-id="element-447">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-50 bg-gradient-to-r from-brand-charcoal to-brand-deep-purple shadow-[0_-10px_40px_rgba(0,0,0,0.2)]" data-id="element-448">
          {/* Gradient Top Border */}
          <div className="h-[2px] w-full bg-gradient-to-r from-brand-teal via-brand-magenta to-brand-orange" data-id="element-449"></div>

          <div className="max-w-7xl mx-auto px-4 py-4 md:px-6 flex items-center justify-between gap-4 relative" data-id="element-450">
            <button onClick={() => {
          setIsDismissed(true);
          setIsVisible(false);
        }} className="absolute top-2 right-2 p-1 text-white/50 hover:text-white transition-colors" aria-label="Close" data-id="element-451">
              <X size={16} data-id="element-452" />
            </button>

            <div className="hidden sm:block" data-id="element-453">
              <p className="text-white font-serif text-lg" data-id="element-454">Ready to talk?</p>
              <p className="text-white/70 text-sm" data-id="element-455">
                Confidential, no-obligation chat.
              </p>
            </div>

            <a href="#consultation" className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 bg-brand-magenta hover:bg-brand-plum text-white px-6 py-3 rounded-sm font-semibold transition-all shadow-lg shadow-brand-magenta/30 text-center text-sm md:text-base" data-id="element-456">
              <Phone size={18} data-id="element-457" />
              Book consultation
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}